import CryptoJS from 'crypto-js';

const ENCRYPTION_KEY = "this-is-my-secret-key-for-token";

export const encryptData = (text) => {
  if (!text) return null; // Handle null/undefined input
  try {
    const ciphertext = CryptoJS.AES.encrypt(text, ENCRYPTION_KEY);
    return ciphertext.toString();
  } catch (error) {
    console.error("Encryption error:", error);
    return null;
  }
};

export const decryptData = (encryptedData) => {
  if (!encryptedData) return null; // Handle null/undefined input
  
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, ENCRYPTION_KEY);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedData || null; // Return null if decryption fails
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};